"use client";

import { usePathname } from "next/navigation";
import { Suspense, useEffect } from "react";
import { env } from "@/env";

export function MetaPixelPageView() {
  return (
    <Suspense fallback={null}>
      <MetaPixelPageViewTracker />
    </Suspense>
  );
}

function MetaPixelPageViewTracker() {
  const pathname = usePathname();

  useEffect(() => {
    window.fbq?.("trackSingle", env.NEXT_PUBLIC_META_PIXEL_ID, "PageView");
  }, [pathname]);

  return null;
}

declare global {
  interface Window {
    fbq?: (
      command: string,
      pixelId: string,
      eventOrOptions?: string | Record<string, unknown>,
      options?: Record<string, unknown>,
      metadata?: Record<string, unknown>,
    ) => void;
  }
}
